var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showTitle)?_c('span',{staticClass:"mr-3",class:{'float-left': _vm.floated}},[_vm._v("\n    "+_vm._s(_vm.actor.title)+"\n  ")]):_vm._e(),_c('display-status-value',{attrs:{"actor":_vm.actor,"only-text":_vm.onTile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }